// extracted by mini-css-extract-plugin
export default {"container":"notification_watcher_count-module__container--L7xMD"};